module.exports = __webpack_public_path__ + "static/media/SF_UI_Display_Regular.7ea26772.eot";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/SF-UI-Display/SF_UI_Display_Regular.eot
// module id = 70
// module chunks = 0